import React from 'react';
import { NumberInput } from 'react-admin';
import Grid from '@material-ui/core/Grid';

const UnifiedEditTax = () => (
  <Grid item xs={12} sm={8} md={8}>
    <NumberInput source="tax_rate_percent" />
  </Grid>
);

export default UnifiedEditTax;
